export class LocalStorageKeys {
  static SessionTimer = 'e_sessionTimer';

  static SessionId = 'e_sessionId';

  static ClientId = 'e_clientId';

  static UserId = 'e_userId';

  static LastCheckedUserId = 'e_lastCheckedUserId';

  static IsTablet = 'e_tablet';

  static IsMobilePhone = 'e_mobilephone';

  static IsDekstop = 'e_desktop';

  static UserIdCookieKey = 'e_userIdCookieKey';

  static IPAddress = 'e_ipAddress';

  static StatsIsBlocked = 'e_statsServiceBlocked';

  static StatsEventsThresholdRemoved = 'e_StatsEventsTresholdRemoved';

  static StatsEventsTransitionObj = 'e_statsEventsTransitionObj';
}
